import React from "react"
import {H2} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import tracking from "@irati-tracking/recognition/recognition"
import pollsTracking from "@irati-tracking/recognition/poll"
import History from "@irati/utils/history"
import Flex from "@irati/ui/src/Flex"
import authentication from "@irati/auth"
import {Hr} from "@irati/ui/src/Layout"
import iconRecognition from "../../images/heart-recognition-card.svg"
import iconSendGreetings from "../../images/send-greeting-icon.svg"
import iconPoll from "../../images/poll-card-icon.svg"
import {RecognitionRoutes} from "../../enums/Routes"
import RewardCardAction from "./RewardCardAction"
import CardAction, {CardActionProps} from "./CardAction"
const CardActions: CardActionProps[] = [
  {
    title: "recognition.global.recogniseSomeone",
    subtitle: "recognition.celebrationHub.recognitionSubtitle",
    img: iconRecognition,
    onClick: (context) => {
      tracking.startCreateRecognition()
      History.push(RecognitionRoutes.CREATE_RECOGNITION, context)
    }
  },
  {
    title: "recognition.celebrationHub.groupCelebration.header",
    subtitle: "recognition.celebrationHub.groupCelebration.subtitle",
    img: iconSendGreetings,
    onClick: (context) => {
      tracking.startCreateRecognition("button", "greeting_card")
      History.push(RecognitionRoutes.CREATE_GROUP_CELEBRATION, context)
    }
  },
  {
    title: "recognition.celebrationHub.poll.header",
    subtitle: "recognition.celebrationHub.poll.subtitle",
    img: iconPoll,
    hasPermissions: () => !!authentication.apps("recognition.poll.create"),
    onClick: (context) => {
      pollsTracking.startCreatePoll()
      History.push(RecognitionRoutes.CREATE_POLL, context)
    }
  }
]

const CelebrationHubHeader = () => {
  return (
    <Flex marginTop={5} direction="column">
      <H2>
        <FormattedMessage id="recognition.hub.header" />
      </H2>
      <Flex marginTop={3} gap={2} wrap="wrap">
        <RewardCardAction />
        {CardActions.filter(({hasPermissions}) => (hasPermissions ? hasPermissions() : true)).map((actionProps, index) => (
          <CardAction {...actionProps} key={index} />
        ))}
      </Flex>
      <Hr marginTop={5} />
    </Flex>
  )
}

export default CelebrationHubHeader
